let activeFilters = [];

const initFilter = (selectName, filterDataAttr) => {
  const selects = document.querySelectorAll( selectName );
  const allEvents = document.querySelectorAll( '.event-archive__event' );

  if (!selects) return;

  selects.forEach( select => {
    select.addEventListener( 'change', (event) => {
      event.preventDefault();

      const filter = select.value;

      if ('all' !== filter) {
        activeFilters[filterDataAttr] = filter;
      } else {
        delete activeFilters[filterDataAttr];
      }

      const filterSelector = Object.keys( activeFilters ).map( key => `[${key}="${activeFilters[key]}"]` ).join( '' ) || '.event-archive__event';
      const items = document.querySelectorAll( filterSelector );

      allEvents.forEach( item => {
        item.classList.add( 'hidden' );
      } );

      items.forEach( item => {
        item.classList.remove( 'hidden' );
      } );


      cleanUpMonths();
      updateAmountOfEvents( document.querySelectorAll( '.event-archive__event:not(.hidden)' ).length );
    } );
  } );
}

const updateAmountOfEvents = (amount) => {
  const amountOfEvents = document.querySelector( '.event-filter__num-results__count' );
  amountOfEvents.textContent = amount;
}

const cleanUpMonths = () => {
  const months = document.querySelectorAll( '.event-archive__month' );
  months.forEach( month => {
    if (monthIsEmpty( month )) {
      month.classList.add( 'hidden' );
    } else {
      month.classList.remove( 'hidden' );
    }
  } );
}

const monthIsEmpty = (month) => {
  return month.querySelectorAll( '.event-archive__event' ).length === month.querySelectorAll( '.hidden' ).length;
}

const initEventFilters = () => {
  initFilter( '[name="event-filter--type"]', 'data-filter-type' );
  initFilter( '[name="event-filter--for-who"]', 'data-filter-for-who' );
  initFilter( '[name="event-filter--network"]', 'data-filter-network' );
}

const toggleFiltersOnMobile = () => {
  const filterToggles = document.querySelectorAll( '.event-archive__filter__button' );
  const filters = document.querySelectorAll( '[name^="event-filter--"]' );

  filterToggles.forEach( toggle => {
    toggle.addEventListener( 'click', (event) => {
      event.preventDefault();

      toggle.setAttribute( 'aria-expanded', toggle.getAttribute( 'aria-expanded' ) === 'true' ? 'false' : 'true' );

      filters.forEach( filter => {
        filter.classList.toggle( 'show' );
      } );
    } );
  } );
}

export default {
  init() {
    initEventFilters();
    toggleFiltersOnMobile();
  },
};